import React, { Fragment } from 'react';
import { Global } from '@emotion/core';
import printStyles from 'pages/BookingConfirmation/printStyles';
import Disclaimer from './Disclaimer';
import GlobalFooter from './GlobalFooter';

const Footer = () => (
  <Fragment>
    <Global styles={printStyles} />
    <Disclaimer />
    <GlobalFooter />
  </Fragment>
);

export default Footer;
